// extracted by mini-css-extract-plugin
export default {"dragAndDropCTA":"DnDCTA_dragAndDropCTA__VyJh"};